export const enum MutationNames {
  updateSites = 'SITES_UPDATE_SITES',
}

export const enum ActionNames {
  getSites = 'SITE_GET_SITES',
  patchSite = 'SITE_PATCH_SITE',
}

export const enum GetterNames {
  sites = 'SITE_SITES',
}
